/* eslint-disable jsx-a11y/anchor-is-valid */
// import {
//   DtpNoContent,
// } from 'dtp-react-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { manterApenasFiltro } from '../utils/helpers';
import { solicitarHabilitarQualificacao } from '../utils/requests';
import './Inicio.css';
import InfoCronograma from '../pages/cadastros/cronograma-pagamentos/InfoCronograma';
import '../pages/cadastros/cronograma-pagamentos/impressaoCronogramaPagamento.css';
import { Button } from '../components';

// const STYLES_CSS = {
//   painelGeral: {
//     textAlign: 'left',
//     margin: '0 auto',
//   },
// };

class Inicio extends Component {
  componentDidMount() {
    manterApenasFiltro('');
    if (!this.props.configuracoesFrontend) {
      solicitarHabilitarQualificacao();
    }
    // solicitarPendenciasPorEnteLogado();
  }

  getMessage = (chave) => {
    let texto = '';
    if (this.props.configuracoesFrontend && this.props.configuracoesFrontend.listaMensagens) {
      const mensagem = this.props.configuracoesFrontend.listaMensagens.filter(m => m.chave === chave);
      if (mensagem.length > 0) {
        texto = mensagem[0].valor;
      }
    }
    return texto;
  }

  showPendencia = (visao) => {
    this.props.history.push(`/controledepagamentos/home/${visao}/pendencias`);
  }

  montaLinkPendencias = (visao) => {
    let textoVisao = '';
    let nomeParticipante = '';

    if (visao === 1) {
      textoVisao = 'análise de pagamento';
    }
    if (visao === 2) {
      textoVisao = 'valores a pagar';
    }

    if (this.props.configuracoesFrontend && this.props.configuracoesFrontend.nomeParticipantePendencia) {
      nomeParticipante = this.props.configuracoesFrontend.nomeParticipantePendencia;
    }

    const botaoLink = (
      <span style={
          {
            align: 'left',
            top: '-4px',
            position: 'relative',
          }
        }
      >
        <Button
          hint={(this.props.configuracoesFrontend && nomeParticipante) ?
            `Pendências de ${textoVisao} identificados para o ente ${nomeParticipante}.` : ''}
          icon="ico-money-bag"
          mini
          onClick={() => this.showPendencia(visao)}
        />
      </span>
    );

    const textoLink = (
      <span style={{ color: '#C32F27' }}>
        {(this.props.configuracoesFrontend && nomeParticipante) ? `Pendências de ${textoVisao} identificadas para o ente ${nomeParticipante}.` : ''}
      </span>
    );

    return (
      <React.Fragment>
        {botaoLink}{textoLink}
      </React.Fragment>
    );
  }

  mensagemBloqueio = () => {
    const URLS = {
      comprev: 'https://servicos.dataprev.gov.br/comprev/',
      sprev: 'https://www.gov.br/trabalho-e-previdencia/pt-br/assuntos/previdencia-no-servico-publico/compensacao-previdenciaria/compensacao-previdenciaria',
      faq: 'https://docs.dataprev.gov.br/docs/comprev/perguntas-frequentes/',
    };
    const EMAIL = 'comprev@dataprev.gov.br';

    return (
      <div style={{
        textAlign: 'justify', fontSize: '16px', lineHeight: '2.2', color: '#C32F27', fontWeight: 'bold',
      }}
      >
        A contratação do COMPREV será realizada por meio do marketplace (<a href={URLS.comprev}>{URLS.comprev}</a>).
        Não é possível a celebração do contrato por outro canal.
        O primeiro passo antes de iniciar o processo de contratação do COMPREV junto à DATAPREV,
        é importante que o Ente se certifique que está devidamente habilitado pela SPREV para contratar o COMPREV.
        Após a celebração do Termo de Adesão junto a SPREV, o Ente está apto para realizar a contratação do COMPREV junto à DATAPREV.
        Para tanto, o Ente deverá acessar o portal da SPREV <a href={URLS.sprev}>{URLS.sprev}</a> e acessar
        os documentos (Projeto Básico, Minuta de Contrato e Modelo de Negócio) que serão necessários para o Ente instaurar o processo
        administrativo de contratação do COMPREV. É importante que o Ente siga as recomendações de preenchimento presentes nesses documentos e que
        não utilize outros documentos que não sejam aqueles disponibilizados no portal da SPREV.
        Após a conclusão das etapas internas relativas à contratação, o Ente deverá acessar o marketplace da DATAPREV <a href={URLS.comprev}>{URLS.comprev}</a> e
        preencher o formulário eletrônico com todas as informações solicitadas.
        Existem dois canais de relacionamento para dirimir dúvidas com os Entes relacionadas à Contratação do COMPREV.
        1 - Sala Virtual, sempre terças e quintas, das 09:30h às 12:00h e 14:30 às 17:00. Para solicitar acesso e participar, basta ligar para o número (61) 2021-5555.
        2 - Caixa de Email do COMPREV: <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
        Segue link do FAQ relacionado à contratação do COMPREV: <a href={URLS.faq}>{URLS.faq}</a>
      </div>
    );
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        {this.props.configuracoesFrontend && this.props.configuracoesFrontend.exibirLinkPesquisaPendenciasAReceber &&
          <div
            className="esconder-print"
            style={{
              width: '1380px', margin: '0 auto', padding: '40px 6px 20px 6px', textAlign: 'left',
            }}
          >
            <h2 style={{ fontSize: '20px' }}>
              {this.montaLinkPendencias(1)}
            </h2>
          </div>
        }
        {this.props.configuracoesFrontend && this.props.configuracoesFrontend.exibirLinkPesquisaPendenciasAPagar &&
          <div
            className="esconder-print"
            style={{
              width: '1380px', margin: '0 auto', padding: '20px 6px', textAlign: 'left',
            }}
          >
            <h2 style={{ fontSize: '20px' }}>
              {this.montaLinkPendencias(2)}
            </h2>
          </div>
        }
        {this.props.configuracoesFrontend && this.props.configuracoesFrontend.temBloqueioAtivoContratoDtp &&
          <div
            id="alerta-bloqueio"
            style={{
              width: '1380px', margin: '0 auto', padding: '20px 6px', textAlign: 'left',
            }}
          >
            <span style={{
              display: 'block', color: 'red', fontWeight: 'bold', fontSize: '14px',
            }}
            >
              {this.mensagemBloqueio()}
            </span>
          </div>
        }
        <div
          className="esconder-print"
          style={{
            width: '1380px', margin: '0 auto', padding: '20px 6px', textAlign: 'left', marginBottom: '40px',
          }}
        >
          <span style={{
            display: 'block', fontSize: '24px', color: '#3060A0', fontWeight: 'bold', paddingTop: '30px',
          }}
          >
            {this.getMessage('msgprimaria')}
          </span>
          <span style={{
            display: 'block', fontSize: '24px', color: '#3060A0', marginTop: '8px', fontWeight: 'bold',
          }}
          >
            {this.getMessage('msgsecundaria')}
          </span>
        </div>
        <InfoCronograma />
      </div>
    );
  }
}

Inicio.defaultProps = {
  configuracoesFrontend: null,
};

Inicio.propTypes = {
  configuracoesFrontend: PropTypes.arrayOf(PropTypes.string),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const mapStateToProps = state => ({
  filtroBloqueio: state.base.filtroBloqueio,
  configuracoesFrontend: state.base.configuracoesFrontend,
});

export default connect(mapStateToProps)(Inicio);



// WEBPACK FOOTER //
// ./src/pages/Inicio.jsx